<template>
  <div>
    <el-input-number
      size="small"
      v-model="num"
      controls-position="right"
      :min="0"
      :step="1"
      :precision="0"
      :step-strictly="true"
      :max="999"
      :style="{width:'88px'}"
    ></el-input-number>
    <div class="add-btn-container">
      <el-button type="primary" plain size="mini" @click="handleAddToCart" :disabled="!num">Add</el-button>
    </div>
  </div>
</template>

<script>
import { save } from '../providers/store-parser'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'ColumnAddToCart',
  props: {
    row: {
      type: Object,
      required: true
    },
    setter: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      num: ''
    }
  },
  created () {
    this.bus.$on('new-search', this.newSearchCb)
  },
  computed: {
    ...mapState('search', ['csr'])
  },
  methods: {
    ...mapActions({
      saveCsr: 'cart/saveCsr'
    }),
    handleAddToCart () {
      if (this.csr.id) {
        this.saveCsr(this.csr)
      }
      save(this.setter, { ...this.row, qty: this.num || 0 })
    },
    newSearchCb () {
      this.num = ''
    }
  },
  beforeDestroy () {
    this.bus.$off('new-search', this.newSearchCb)
  },
  inject: ['bus']
}
</script>

<style lang="scss" scoped>
.add-btn-container {
  display: inline-block;
  margin-left: 8px;
}
</style>
